// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__yPd7s","name":"Header_name__BPdlF","birthday":"Header_birthday__3mELe","skeleton":"Header_skeleton__rK6bV"};